import React from "react";

import { Field, ValidationError } from "affinityUI/form/components";
import { Checkbox } from "affinityUI/form/inputs/checkbox";

import { useAffinityField } from "../../helpers";

export const CheckboxField: React.FC<
  Omit<React.ComponentProps<typeof Checkbox>, "name"> & {
    name: string;
  }
> = ({ children, ...props }) => {
  const { name, value } = props;
  const [{ value: fieldValue, onChange, ...field }, meta] = useAffinityField({ name, value });
  const handleChange = React.useCallback<React.ChangeEventHandler<HTMLInputElement>>(
    (e) => {
      onChange({ ...e, target: { ...e.target, name, value: e.target.checked } });
    },
    [name, onChange]
  );
  return (
    <Field>
      <Checkbox
        id={name}
        error={meta?.error}
        {...field}
        {...props}
        onChange={handleChange}
        checked={Boolean(fieldValue)}
      >
        {children}
      </Checkbox>
      {meta?.error && <ValidationError>{meta?.error}</ValidationError>}
    </Field>
  );
};
